document.addEventListener('DOMContentLoaded',function(){
  var announcementSlider = new Swiper('.Custom-announcementSlider.swiper', {
    loop: false,
    slidesPerView: 1
  })

  // In search append Dynamic text
    var dynamicText = document.body.getAttribute("DymaicTxt");
    var dynamicTextArray = dynamicText.split(',');
    var options = {
    strings: dynamicTextArray,
    typeSpeed: 70, // typing speed in milliseconds
    backSpeed: 50, // backspacing speed in milliseconds
    loop: true, // loop the animation
    cursorChar: "",
   };

    var typed = new Typed("#searchText", options);
  var typedMB = new Typed("#MB_searchText", options);
    });

        var closeButton = document.getElementById("closeButton");
      var inputField = document.getElementById("searchtest");
      
      var element = document.querySelector(".Dekstop_Predective_Serach");
      
      closeButton.addEventListener("click", function() {
        if (element) {
          element.style.display = "flex";
        }
      });
      
      inputField.addEventListener("click", function() {
      
        if (element.style.display === "none") {
          element.style.display = "block";
        } else {
          element.style.display = "none";
        closeButton.classList.remove("hidden");
          document.getElementById("Search-In-Modal").focus();
        }
      });

      for (var i = 0; i < 5; i++) {
      const buttonsContainer = document.getElementById("activeTab"+i);
      var mainPageTitle = document.querySelector('.JPS_MainPAgeTile h1');
     if(buttonsContainer != null ){
     buttonsContainer.addEventListener("click", function(e) {
     var spanValue = this.querySelector('.JPS_PressNoteTabStyle span').innerText;
        mainPageTitle.innerText = spanValue;
      })
     }
    }

   const buttonsContainer = document.getElementById("activeTab1");
   if(buttonsContainer)
   var spanValue = buttonsContainer.querySelector('.JPS_PressNoteTabStyle span').innerText;
    if(spanValue)
   mainPageTitle.innerText = spanValue;

let button = document.querySelector('.OffersAvailable .Offerstxtie ');
let addoff = document.querySelector('.InnerOfferAvailable');
let drawerOuter = document.querySelector('.drawer__footer');
let drawersummary = document.querySelector('.InnerPrice_Summary');
let crossbutton = document.querySelector('.CrossICon');
let summarycross = document.querySelector('.Caret .CrossSlide_arrow');
let summary = document.querySelector('.MainPrice_Summary');

  button.addEventListener('click', function() {
    addoff.classList.add('offeractive');
    drawerOuter.classList.add('Clickoffer');
     document.body.classList.add("DrawerAccordion");
    summary.removeAttribute('open');
  });

  crossbutton.addEventListener('click', function() {
    addoff.classList.remove('offeractive');
      document.body.classList.remove("DrawerAccordion");
     drawerOuter.classList.remove('Clickoffer');
  });


  drawersummary.addEventListener('click', function() {
    drawerOuter.querySelector('.summary__title').classList.toggle('SummaryOffers');
     document.body.classList.toggle("DrawerAccordion");
  });

 summarycross.addEventListener('click', function(e) {
   this.closest('.summary__title').classList.remove('SummaryOffers');
      document.body.classList.remove("DrawerAccordion");
  });


  function copyToClipboard(textSelector) {
    const textToCopy = document.querySelector(textSelector);
    const selection = window.getSelection();
    const range = document.createRange();
    
    range.selectNodeContents(textToCopy);
    selection.removeAllRanges();
    selection.addRange(range);
    
    document.execCommand('copy');
    selection.removeAllRanges();
    const applyDiv = document.querySelector('.applyDiv');
    applyDiv.querySelector('#copyButtonText p').innerHTML = 'Copied';
    setTimeout(function(){
      applyDiv.querySelector('#copyButtonText p').innerHTML = 'Copy'
    },2000);    
  }

if( document.querySelector('.cp1') ){
  document.querySelector('.cp1').addEventListener('click', function() {
    copyToClipboard('.OfferCode p');
  });
};

if( document.querySelector('.cp2') ){
  document.querySelector('.cp2').addEventListener('click', function() {
    copyToClipboard('.OfferCode p');
  });
};

if(  document.querySelector('#copyButtonText') ){
  document.querySelector('#copyButtonText').addEventListener('click', function() {
    copyToClipboard('#textToCopy p');
  });
}